import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { QueryClientProvider, QueryClient } from "react-query";
// import { useIdleTimer } from "react-idle-timer";
import { ThemeProvider } from "@mui/material/styles";
import customTheme from "./config/themeConfig";
import { AuthContextProvider } from "./contexts/AuthContext";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import KycForm from "./pages/KycForm/KycForm";
import AdminLogin from "./pages/Admin/Login/Login";
import Logout from "./pages/Logout/Logout";
import AdminRoutes from "./pages/Admin/KycUpdate/Initiator/AdminRoutes";
import LandingPage from "./pages/Admin/LandingPage/LandingPage";
import AdminSubmissionRoutes from "./pages/Admin/KycSubmission/AdminRoutes";
import AdminAuthorizerUpdateRoutes from "./pages/Admin/KycUpdate/Authorizer/AdminRoutes";
import ProtectedRoute from "./components/common/ProtectedRoutes";
import "react-toastify/dist/ReactToastify.css";

function App() {
	const queryClient = new QueryClient();

	return (
		<ThemeProvider theme={customTheme}>
			<QueryClientProvider client={queryClient}>
				<AuthContextProvider>
					<Router>
						<div className="App">
							<ToastContainer />
							<Switch>
								<Route path="/admin/login" exact component={AdminLogin} />
								<ProtectedRoute
									exact
									path="/admin/landing-page"
									component={LandingPage}
								/>
								<ProtectedRoute
									path="/admin/kyc-submission"
									component={AdminSubmissionRoutes}
								/>
								<ProtectedRoute
									path="/admin/kyc-update/initiator"
									component={AdminRoutes}
									userRole="initiator"
								/>
								<ProtectedRoute
									path="/admin/kyc-update/authorizer"
									component={AdminAuthorizerUpdateRoutes}
									userRole="authorizer"
								/>
								<Route exact path="/logout" component={Logout} />
								<Route path="/" exact component={KycForm} />
								<Route path="*" component={NotFoundPage} />
							</Switch>
						</div>
					</Router>
				</AuthContextProvider>
			</QueryClientProvider>
		</ThemeProvider>
	);
}

export default App;
